<template>
  <PageContainer>
    <!-- HERO -->
    <SectionContainer>
      <div v-if="auth" class="uppercase text-xl">You are invited to the wedding of</div>
      <h1>Ella & Khanh</h1>
      <div class="uppercase text-4xl">26 Feb 2026</div>
      <div class="uppercase text-xl">Philippines</div>
      <button v-if="auth" @click="goToRSVP()" class="mt-8">RSVP</button>
      <button v-else @click="goToAuthenticate()" class="mt-8">
        <div>I have an invite!</div>
      </button>
    </SectionContainer>

    <!-- PHOTO -->
    <SectionContainer color="theme-pink">
      <img src="@/assets/photo.jpg">
    </SectionContainer>

    <!-- TIMELINE -->
    <SectionContainer v-if="auth">
      <h2>Timeline</h2>
      <p>Thursday, 26 February 2026</p>
      <p>Tagaytay, Philippines</p>
      <div class="w-full mx-auto max-w-md text-left">
        <h3 class="ml-6">Ceremony</h3>
        <a href="https://maps.app.goo.gl/3dRpuJiuKQ8EsR6q8">
          <p class="ml-6">📍 <span class="underline">St. Benedict Parish</span></p>
        </a>
        <ol class="relative border-s border-theme-navy mt-4 ml-12">                  
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">9:30 AM</p>
            <p class="w-2/3">Guest Arrival</p>
          </li>
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">10:00 AM</p>
            <p class="w-2/3">Ceremony</p>
          </li>
        </ol>
        <h3 class="ml-6">Reception</h3>
        <a href="https://maps.app.goo.gl/7sJ6gxc7YQLyFPTE8">
          <p class="ml-6">📍 <span class="underline">Aquila Crystal Palace</span></p>
        </a>
        <ol class="relative border-s border-theme-navy mt-4 ml-12">                  
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">4:00 PM</p>
            <p class="w-2/3">Guest Arrival</p>
          </li>
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">4:30 PM</p>
            <p class="w-2/3">Photos</p>
          </li>
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">5:30 PM</p>
            <p class="w-2/3">Reception</p>
          </li>
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">6:30 PM</p>
            <p class="w-2/3">Dinner</p>
          </li>
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">8:00 PM</p>
            <p class="w-2/3">Party</p>
          </li>
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">10:00 PM</p>
            <p class="w-2/3">After Party</p>
          </li>
        </ol>
      </div>
    </SectionContainer>

    <!-- FOOTER -->
    <!-- <SectionContainer> -->
      <!-- LOGO -->
    <!-- </SectionContainer> -->
  </PageContainer>
</template>

<script>
import PageContainer from '@/pages/PageContainer'
import SectionContainer from '@/pages/SectionContainer'
import Group from '@/models/group'

export default {
  name: 'HomePage',
  components: {
    PageContainer,
    SectionContainer,
  },
  data() {
    return {
      auth: undefined,
    }
  },
  beforeMount() {
    this.loadAuth()
  },
  methods: {
    async loadAuth() {
      const secret = this.$route.query.group
      if (secret) {
        this.auth = await Group.auth(secret)
      } else {
        this.auth = await Group.current()
      }
    },
    goToAuthenticate() {
      this.$router.push('/login')
    },
    goToRSVP() {
      this.$router.push('/rsvp')
    },
  },
}
</script>